export default __webpack_public_path__ + "static/media/san-mateo.78d4467e.jpg";